<template>
    <div class="container -clients">
        <ol class="breadcrumb">
            <li><a v-link="{name: 'home'}">Accueil</a></li>
            <li>Membres</li>
        </ol>

        <div class="heading f -wrap -a-center">
            <h1 class="expand">Membres</h1>

            <a v-link="{'name': 'clients-add'}"
               class="btn btn-primary -add">
                <i class="glyphicon glyphicon-plus"></i> Ajouter un membre
            </a>
        </div>

        <div class="search-area">
            <div class="search-row f -a-center">
                <div class="form-group expand">
                    <label for="clients-search"
                           class="sr-only">
                        Chercher un membre
                    </label>
                    <div class="input-group">
                        <div class="input-group-addon">
                            <loader v-show="loading"></loader>
                            <i v-show="!loading" class="glyphicon glyphicon-search"></i>
                        </div>
                        <input type="text"
                               class="form-control"
                               id="clients-search"
                               v-model="searchQuery"
                               placeholder="Chercher un nom, un numéro de téléphone, etc">
                    </div>
                </div>

                <a href="#"
                   v-on:click.prevent="downloadExcel"
                   class="btn btn-default">
                    <span v-show="!generatingExcel">.xlsx</span>
                    <loader v-show="generatingExcel"></loader>
                </a>
            </div>

            <div class="filter-tabs">
                <radio-group :value.sync="filterTab"
                             type="info">
                    <radio-btn v-for="filter of (filters || [])"
                               :id="'clients-list-filter-' + filter.param"
                               :class="filterBtnClass(filter)"
                               :value="filter.param">
                        {{ filter.name }}
                    </radio-btn>
                </radio-group>

                <button class="btn btn-default"
                        @click.prevent="resetFilters()">
                    Réinitialisation
                </button>
            </div>

            <div class="filters"
                 :id="'clients-list-filter-' + filterTab">
                <template v-for="filter of (filters || [])">
                    <template v-if="filter.param === filterTab">
                        <enum-filter v-if="filter.type === 'enum'"
                                     :selection.sync="filterSelection[filter.param]"
                                     :filter.sync="filter"></enum-filter>
                        <range-filter v-if="filter.type === 'range'"
                                      :selection.sync="filterSelection[filter.param]"
                                      :filter.sync="filter"></range-filter>
                    </template>
                </template>
            </div>
        </div>

        <table class="table table-hover -clients -row-links">
            <tr>
                <th>Nom</th>
                <th>Status</th>
                <th>Sources</th>
                <th>Carac.</th>
                <th>Risque</th>
                <th>Projets</th>
                <th class="number-col">C. init.</th>
                <th class="number-col">Versements</th>
                <th>Communauté</th>
                <th>Conseiller</th>
            </tr>

            <tr v-for="client in clients">
                <td class="name-col"><a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                    {{ client.name }}
                </a></td>
                <td class="right-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        <span v-if="client.status === 'client'">membre</span>
                        <span v-if="client.status === 'prospect'">prospect</span>
                        <small v-if="client.active">(actif)</small>
                    </a>
                </td>
                <td class="right-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        <span v-for="source in client.sources">
                            <span v-if="source === 'alpinia'">AF</span>
                            <span v-if="source === 'activeseed'">AS</span>
                        </span>
                    </a>
                </td>
                <td class="right-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        {{ adjective(client) }}
                    </a>
                </td>
                <td class="right-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        {{ asProfile(client) }}
                    </a>
                </td>
                <td class="right-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        <span class="badge"
                              v-for="plan of lifePlans(client)">
                            {{ plan }}
                        </span>
                    </a>
                </td>
                <td class="right-col number-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        {{{ client.capital | money }}}
                    </a>
                </td>
                <td class="right-col number-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        {{{ client.payment | money }}}
                    </a>
                </td>
                <td class="right-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        {{ client.activeseed && client.activeseed.source || '' }}
                    </a>
                </td>
                <td class="right-col">
                    <a href="#"
                       v-link="{name: 'clients-detail', params: {id: client.id}}">
                        {{ client.activeseed && client.activeseed.advisor_name || '' }}
                    </a>
                </td>
            </tr>
        </table>

        <loader v-show="loading" class="bigger-loader"></loader>

        <div class="load-more">
            <a href="#"
               v-if="hasNext && !loading"
               v-on:click.prevent="updateList(true)"
               class="btn btn-default">
                Charger plus
            </a>
        </div>
    </div>
</template>

<style scoped
       type="text/less"
       lang="less">
    @import '~src/style/variables';
    @import (reference) '~bootstrap/less/mixins/vendor-prefixes';
    @import (reference) '~bootstrap/less/mixins/tab-focus';
    @import (reference) '~bootstrap/less/mixins/opacity';
    @import (reference) '~bootstrap/less/mixins/buttons';
    @import (reference) '~bootstrap/less/buttons';

    .heading {
        margin-bottom: @grid-gutter-width;

        h1 {
            margin: 0;
        }
    }

    .search-area {
        margin-bottom: @grid-gutter-width;
    }

    .search-row .form-group {
        flex-basis: 0;
        margin: 0;
        margin-right: @grid-gutter-width;
    }

    .filter-tabs,
    .filters {
        margin-top: (@grid-gutter-width / 2);
    }

    .number-col {
        text-align: right;
    }

    .name-col {
        min-width: 190px;
    }

    .load-more {
        margin: @grid-gutter-width 0;
        text-align: center;
    }

    .bigger-loader {
        font-size: 120%;
    }

    .btn-active {
        .btn-warning() !important;
    }
</style>

<script type="text/ecmascript-6">
    import {
        list,
        downloadUrl,
        getAdjectiveDisplay,
        getFilters
    } from '../api/client';
    import Loader from '../components/Loader';
    import EnumFilter from '../components/clients/EnumFilter';
    import RangeFilter from '../components/clients/RangeFilter';
    import {asyncDebounce, makeUpdateList} from '../utils';
    import RadioGroup from 'vue-strap/src/radioGroup';
    import RadioBtn from 'vue-strap/src/radioBtn';

    export default {
        components: {
            Loader,
            RadioGroup,
            RadioBtn,
            EnumFilter,
            RangeFilter
        },
        data() {
            return {
                searchQuery: '',
                clients: [],
                page: 1,
                hasNext: false,
                generatingExcel: false,
                loading: false,
                filterTab: '',
                filterSelection: {},
                filters: []
            };
        },
        ready() {
            this.updateList();

            getFilters().then((data) => {
                this.filters = data.filters;
                this.resetFilters();
            });
        },
        watch: {
            searchQuery() {
                this.updateList();
            },
            filterSelection: {
                deep: true,
                handler() {
                    this.updateList();
                }
            }
        },
        methods: {
            updateList: makeUpdateList({
                loading: 'loading',
                page: 'page',
                hasNext: 'hasNext',
                list: 'clients',
                fetch: async function (page) {
                    return await list(
                        this.searchQuery,
                        this.filters,
                        this.filterSelection,
                        page
                    );
                }
            }),
            downloadExcel: asyncDebounce(async function () {
                this.generatingExcel = true;

                const url = (await downloadUrl(
                    this.searchQuery,
                    this.filters,
                    this.filterSelection
                )).url;
                const iframe = document.createElement('IFRAME');
                iframe.setAttribute('src', url);
                iframe.style.display = 'none';
                document.body.appendChild(iframe);

                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 10000);

                this.generatingExcel = false;
            }),

            /**
             * Returns a displayable adjective for this client
             */
            adjective(client) {
                if (!client ||
                        !client.activeseed ||
                        !client.activeseed.adjective) {
                    return '';
                }

                return getAdjectiveDisplay(client.activeseed.adjective);
            },

            /**
             * Format the AS risk profile
             */
            asProfile(client) {
                const profile = client &&
                    client.activeseed &&
                    client.activeseed.as_profile;

                if (profile) {
                    return profile.replace('_', ' - ');
                }

                return '';
            },

            /**
             * Shorten and format the life plans list
             */
            lifePlans(client) {
                const plans = client && client.life_plans;

                if (!plans) {
                    return [];
                }

                const out = [];
                let i;

                for (i = 0; i < Math.min(2, plans.length); i += 1) {
                    out.push(plans[i].slice(0, 4) + '.');
                }

                if (i < plans.length) {
                    out.push(`+${plans.length - i}`);
                }

                return out;
            },

            /**
             * Checks if a given filter is active and if it is active return
             * the 'btn-active' class which overrides the button color and is
             * defined above in the style section (to be a clone of
             * btn-warning)
             */
            filterBtnClass(filter) {
                if (filter.type === 'enum') {
                    if ((this.filterSelection[filter.param] || []).length) {
                        return 'btn-active';
                    }
                } else if (filter.type === 'range') {
                    const range =
                        this.filterSelection[filter.param] || ['', ''];

                    if (range[0] !== '' || range[1] !== '') {
                        return 'btn-active';
                    }
                }

                return '';
            },

            /**
             * Restore the current filters to the initial state
             */
            resetFilters() {
                if (this.filters.length) {
                    this.filterTab = this.filters[0].param;
                }

                const selection = {};

                for (const f of this.filters) {
                    if (f.type === 'enum') {
                        selection[f.param] = [];
                    } else if (f.type === 'range') {
                        selection[f.param] = ['', ''];
                    }
                }

                this.filterSelection = selection;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// Clients.vue?8d2996ae